module.exports = __webpack_public_path__ + "img/Speaker=Sofia Dala.53a70dda.png";